// components/common/MultilineField.js - Многострочное поле для длинного текста с авто-ресайзом
import React, { useState, useEffect, useRef } from 'react';

const MultilineField = ({ 
    value, 
    onChange, 
    placeholder = "", 
    className = "", 
    isRequired = false,
    minRows = 1,
    maxRows = 10,
    showValidation = false,
    validationFieldId
}) => {
    const [localValue, setLocalValue] = useState(value);
    const textareaRef = useRef(null);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    // Автоматическая подстройка высоты
    useEffect(() => {
        const textarea = textareaRef.current;
        if (!textarea) return;
        
        const adjustHeight = () => {
            // Сбрасываем высоту для корректного пересчета
            textarea.style.height = 'auto';
            textarea.style.overflowY = 'hidden';
            
            // Вычисляем новую высоту на основе scrollHeight
            const lineHeight = parseFloat(getComputedStyle(textarea).lineHeight);
            const minHeight = lineHeight * minRows;
            const maxHeight = lineHeight * maxRows;
            const scrollHeight = textarea.scrollHeight;
            
            // Проверяем, мобильное ли устройство
            const isMobile = window.innerWidth <= 768;
            
            if (!isMobile && scrollHeight > maxHeight) {
                // На десктопе: если контент больше максимальной высоты, показываем скролл
                textarea.style.height = `${maxHeight}px`;
                textarea.style.overflowY = 'auto';
            } else {
                // На мобильных или если контент меньше maxHeight: растягиваем без скролла
                const newHeight = Math.max(scrollHeight, minHeight);
                textarea.style.height = `${newHeight}px`;
                textarea.style.overflowY = 'hidden';
            }
        };
        
        adjustHeight();
        
        // Добавляем обработчик изменения размера окна
        window.addEventListener('resize', adjustHeight);
        
        return () => {
            window.removeEventListener('resize', adjustHeight);
        };
    }, [localValue, minRows, maxRows]);

    const handleLocalChange = (e) => {
        setLocalValue(e.target.value);
    };

    const handleBlur = () => {
        if (localValue !== value) {
            onChange(localValue);
        }
    };

    const isFilled = localValue && localValue.toString().trim() !== '';
    
    // ✨ Новая логика состояний (аналогично InteractiveField)
    let stateClass = '';
    if (isFilled) {
        stateClass = 'is-filled';
    } else if (isRequired) {
        stateClass = showValidation ? 'is-validation-error' : 'is-pending';
    }
    
    const textareaClassName = `inline-textarea ${className} ${stateClass}`;

    return (
        <span className="editable">
            <textarea
                ref={textareaRef}
                value={localValue || ''}
                onChange={handleLocalChange}
                onBlur={handleBlur}
                placeholder={placeholder}
                className={textareaClassName}
                required={isRequired}
                rows={minRows}
                {...(validationFieldId ? { 'data-validation-field': validationFieldId } : {})}
            />
        </span>
    );
};

export default MultilineField;

